import { Bid, BridgePosition } from '../../app/types';
import { GameEngine, convertIntToBridgePosition, convertIntToCall } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { bridgePos } from '../../app/defaults';
import { convertIntToBid } from '../shark-game-engine-helper';
import { lineForSimpleString } from '../handle-bid-explanation';
import { sfsService } from '../sfs-service';
import moment from 'moment';

export function MID_MADE_BID(cmdObj: SFSObject, sender: GameEngine) {
    const call: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);
    const nextPlayerBridgePosition: number = cmdObj.getInt(SFSVAR.SFSGAME_CURENT_PLAYER);
    const player: BridgePosition = convertIntToBridgePosition(nextPlayerBridgePosition);
    //      this.props.setIsHighlighted(convertIntToBridgePosition(nextPlayerBridgePosition), true);
    if (sfsService.isMiniBridge) {
        return;
    }

    const bridgePositionArray =
        sender.props.table.dealer === BridgePosition.north
            ? [BridgePosition.north, BridgePosition.east, BridgePosition.south, BridgePosition.west]
            : sender.props.table.dealer === BridgePosition.east
            ? [BridgePosition.east, BridgePosition.south, BridgePosition.west, BridgePosition.north]
            : sender.props.table.dealer === BridgePosition.south
            ? [BridgePosition.south, BridgePosition.west, BridgePosition.north, BridgePosition.east]
            : [BridgePosition.west, BridgePosition.north, BridgePosition.east, BridgePosition.south];

    const bid: Bid = {
        bridgePosition: bridgePositionArray[sender.props.table.auction.length % bridgePositionArray.length],
        call: convertIntToCall(call),
        backgroundColor: undefined,
        alertMessage: undefined,
    };

    if (cmdObj.containsKey(SFSVAR.SFSGAME_MID_ALERT)) {
        const { table } = sender.props;
        const playerBridgePosition: number = cmdObj.getInt(SFSVAR.SFSGAME_PLAYER);
        const mybridgeposition: BridgePosition | undefined = table.seatData.bottom.bridgePosition;
        const bidderParnerBridgePossition: BridgePosition = convertIntToBridgePosition(playerBridgePosition ^ 2);
        if (bidderParnerBridgePossition !== mybridgeposition) {
            bid.alertMessage = cmdObj.getUtfString(SFSVAR.SFSGAME_MID_ALERT);
            sender.props.table_setAuxiliaryMessage({
                position: 'left',
                message: {
                    text: bid.alertMessage,
                    bid: bid,
                    titleColor: undefined,
                    buttonOk: undefined,
                    buttonCancel: undefined,
                    buttonAuxiliary: undefined,
                },
            });
        }
    }

    sender.props.table_setAuction([...sender.props.table.auction, bid]);

    sender.setCurrentPlayer(player);
}

export function MID_MADE_BID_SB(cmdObj: SFSObject, sender: GameEngine) {
    sender.props.table_updateTable({ auxiliaryMessages: { left: undefined} });
    const call: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);
    const nextPlayerBridgePosition: number = cmdObj.getInt(SFSVAR.SFSGAME_CURENT_PLAYER);
    const player: BridgePosition = convertIntToBridgePosition(nextPlayerBridgePosition);
    //      this.props.setIsHighlighted(convertIntToBridgePosition(nextPlayerBridgePosition), true);
    //console.log('MID_MADE_BID', cmdObj.getDump(true));
    if (sfsService.getBoolean(SFSVAR.SFSGAME_MINIBRIDGE, false)) {
        return;
    }

    const bridgePositionArray =
        sender.props.table.dealer === BridgePosition.north
            ? [BridgePosition.north, BridgePosition.east, BridgePosition.south, BridgePosition.west]
            : sender.props.table.dealer === BridgePosition.east
            ? [BridgePosition.east, BridgePosition.south, BridgePosition.west, BridgePosition.north]
            : sender.props.table.dealer === BridgePosition.south
            ? [BridgePosition.south, BridgePosition.west, BridgePosition.north, BridgePosition.east]
            : [BridgePosition.west, BridgePosition.north, BridgePosition.east, BridgePosition.south];

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const expl: object | undefined = cmdObj.containsKey('expl')
        ? JSON.parse(new TextDecoder().decode(cmdObj.getByteArray('expl')))
        : undefined;
    let alert: string | undefined = undefined;
    //console.log('Exlanation ', expl);
    if (expl && 'alert' in expl) {
        alert = lineForSimpleString('alert', expl);
        sender.props.table_updateTable({
            chat: [...sender.props.table.chat, { timestamp: moment.utc().format(), sender: 'Alert!', message: alert }],
        });
    } else if (cmdObj.containsKey(SFSVAR.SFSGAME_MID_ALERT)) {
        const { table } = sender.props;
        const playerBridgePosition: number = cmdObj.getInt(SFSVAR.SFSGAME_PLAYER);
        const mybridgeposition: BridgePosition | undefined = table.seatData.bottom.bridgePosition;
        const bidderParnerBridgePossition: BridgePosition = bridgePos(playerBridgePosition ^ 2);
        if (bidderParnerBridgePossition !== mybridgeposition) {
            alert = cmdObj.getUtfString(SFSVAR.SFSGAME_MID_ALERT);
            sender.setSimpleMessage('left', `Alert!, ${alert}`, 'OK');
        }
    }

    const bid: Bid = {
        bridgePosition: bridgePositionArray[sender.props.table.auction.length % bridgePositionArray.length],
        call: convertIntToCall(call),
        backgroundColor: undefined,
        explanation: expl,
        alertMessage: alert,
    };

    const updatedAuction = [...sender.props.table.auction.filter(item => item.call !== 'q'), bid];

    sender.props.table_setAuction(updatedAuction);

    sender.setCurrentPlayer(player);

}
